
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bantuan",
      function () {
        return require("private-next-pages/bantuan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bantuan"])
      });
    }
  